import { render } from "./Pendentes.vue?vue&type=template&id=4a1cf1da"
import script from "./Pendentes.vue?vue&type=script&lang=js"
export * from "./Pendentes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__